import Vue from "vue"
import Component from "vue-class-component"

@Component
export default class StatusMixin extends Vue {
  public toOriginalStatus(status: string): string {
    return toOriginalStatusInternal(status)
  }
}

export function toOriginalStatusInternal(status: string): string {
  if (status === "編集中") {
    return "draft"
  } else if (status === "承認待ち") {
    return "unapproved"
  } else if (
    status === "公開待ち" ||
    status === "公開" ||
    status === "公開終了"
  ) {
    return "publish"
  } else if (status === "非公開") {
    return "unpublish"
  } else {
    return status
  }
}
